import { Clock, DollarSign } from "lucide-react";
import { cn } from "@/lib/utils";

interface ServiceCardProps {
  name: string;
  category: string;
  duration: number;
  price: number;
  description: string;
  active?: boolean;
  selectable?: boolean;
  selected?: boolean;
  onSelect?: () => void;
}

export function ServiceCard({ name, category, duration, price, description, active = true, selectable, selected, onSelect }: ServiceCardProps) {
  return (
    <div
      onClick={selectable ? onSelect : undefined}
      className={cn(
        "rounded-xl border bg-card p-5 transition-all",
        selectable && "cursor-pointer hover:shadow-card hover:border-primary/30",
        selected && "border-primary ring-2 ring-primary/20",
        !active && "opacity-50"
      )}
    >
      <div className="flex items-start justify-between">
        <div>
          <span className="text-xs font-medium uppercase tracking-wider text-primary">{category}</span>
          <h4 className="mt-1 font-semibold text-card-foreground">{name}</h4>
          <p className="mt-1 text-sm text-muted-foreground">{description}</p>
        </div>
      </div>
      <div className="mt-3 flex items-center gap-4 text-sm text-muted-foreground">
        <div className="flex items-center gap-1">
          <Clock className="h-3.5 w-3.5" />
          <span>{duration} min</span>
        </div>
        <div className="flex items-center gap-1">
          <DollarSign className="h-3.5 w-3.5" />
          <span>{price === 0 ? "Free" : `$${price}`}</span>
        </div>
      </div>
    </div>
  );
}
